<template>
    <div>
        <div>
            <C1Label
                v-if="label"
                :label-for="labelFor"
            >
                {{ label }}
            </C1Label>

            <textarea
                :id="id"
                :class="classList"
                :name="name"
                :value="value"
                :placeholder="placeholder"
                :rows="rows"
                :maxlength="maxLength"
                v-on="inputListeners"
            />
        </div>

        <C1HelpText
            v-if="invalidFeedback"
            variant="danger"
        >
            {{ invalidFeedback }}
        </C1HelpText>
    </div>
</template>

<script>
    import C1HelpText from './C1HelpText';
    import C1Label from './C1Label';

    export default {
        name: 'C1FormTextarea',

        components: {
            C1HelpText,
            C1Label,
        },

        props: {
            value: {
                type: String,
                default: '',
            },

            id: {
                type: String,
                default: '',
            },

            placeholder: {
                type: String,
                default: '',
            },

            name: {
                type: String,
                default: '',
            },

            size: {
                type: String,
                default: null,
                validator: value => ['sm', 'lg'].includes(value),
            },

            isInvalid: {
                type: Boolean,
                default: false,
            },

            invalidFeedback: {
                type: [String, Boolean],
                default: false,
            },

            label: {
                type: String,
                default: '',
            },

            labelFor: {
                type: String,
                default: '',
            },

            rows: {
                type: [String, Number],
                default: 4,
            },

            maxLength: {
                type: [String, Number],
                default: '',
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    this.getDefaultClass,
                    this.getTextColorClass,
                    this.getTextSizeClass,
                    this.getBorderClass,
                    this.getPaddingClass,
                ];
            },

            getDefaultClass() {
                let output = 'af-input af-textarea';
                if (this.size) {
                    output += ` af-input-${this.size}`;
                }

                output += ' afu-block afu-border afu-border-solid focus:afu-outline-none afu-appearance-none afu-rounded afu-w-full afu-transition afu-duration-150 afu-ease-in-out';

                return output;
            },

            getTextColorClass() {
                return 'afu-text-black afu-placeholder-custom';
            },

            getTextSizeClass() {
                const sizes = {
                    default: 'afu-text-7xl afu-font-normal',
                    sm: 'afu-text-7xl afu-font-normal',
                    lg: 'afu-text-7xl afu-font-normal',
                };

                return sizes[this.size] || sizes.default;
            },

            getBorderClass() {
                if (this.isInvalid) {
                    return 'afu-border-danger-400 focus:afu-border-danger-500';
                }

                return 'afu-border-gray-400 focus:afu-border-gray-700';
            },

            getPaddingClass() {
                const sizes = {
                    default: 'afu-py-2 afu-px-3',
                    sm: 'afu-py-2 afu-px-3',
                    lg: 'afu-py-3 afu-px-5',
                };

                return sizes[this.size] || sizes.default;
            },

            inputListeners() {
                const vm = this;
                return {
                    ...this.$listeners,
                    input(event) {
                        vm.$emit('input', event.target.value);
                    },
                    change(event) {
                        vm.$emit('change', event.target.value);
                    },
                    blur(event) {
                        vm.$emit('blur', event);
                    },
                };
            },
        },
    };
</script>
